






















import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
    props: {
        voltage: { type: Number, required: true },
        loading: { type: Boolean, default: false },
        warning: { type: Boolean, default: false },
        imageSrc: {
            type: String,
            required: false,
            default: "batteri-ladeniveau-forside_hvid70"
        }
    },
    setup(props) {
        const imgSrc = computed(() => {
            return require(`@/assets/icons/${props.imageSrc}.svg`);
        });
        return {
            imgSrc
        };
    }
});
